// "Mis plataformas" — owner-only (mismo lock que el backend, routes/myPlatforms.js).
export const MY_PLATFORMS_USER_IDS = new Set(['eafdff80-02d2-4eef-9e5c-19f57761b85d']);
export const canUseMyPlatforms = (user, isImpersonating) =>
  !!user && MY_PLATFORMS_USER_IDS.has(user.id) && !isImpersonating;
